// Translation: Ukrainian > Actions
const actions = Object.freeze({
	refreshPage: '',
	startOver: ''
})

// Export
export default actions
